import React from 'react'
import { Box, Image, Text } from 'grommet'
import styled from 'styled-components'
import LogoImage from '../../images/Picker-Wheel-Logo-Small.png'

const LogoText = styled(Text)`
  display: inline-block;
  width: max-content;
  white-space: nowrap;
  font-size: inherit;
  letter-spacing: ${props => (!props.smallSpacing ? 'normal' : '-0.9px')};
`

const PageLogo = React.memo(({ page }) => {
  let logoText = 'Picker Wheel'
  switch (page) {
    case 'rtg':
      logoText = 'Team Picker Wheel'
      break
    case 'ynw':
      logoText = 'Yes No Picker Wheel'
      break
    case 'rng':
      logoText = 'Number Picker Wheel'
      break
    case 'rlg':
      logoText = 'Letter Picker Wheel'
      break
    case 'rig':
      logoText = 'Image Picker Wheel'
      break
    case 'rdg':
      logoText = 'Date Picker Wheel'
      break
    case 'icp':
      logoText = 'Instagram Comment Picker Wheel'
      break
    case 'rcg':
      logoText = 'Country Picker Wheel'
      break
    case 'rcw':
      logoText = 'Color Picker Wheel'
      break
    case 'nfl':
      logoText = 'NFL Picker Wheel'
      break
    case 'nba':
      logoText = 'NBA Picker Wheel'
      break
    case 'mlb':
      logoText = 'MLB Picker Wheel'
      break
    case 'rsg':
      logoText = 'State Picker Wheel'
      break
  }
  return (
    <Box
      direction="row"
      align="center"
      justify="center"
      gap="0.5rem"
      margin={{ top: '2rem' }}
    >
      <Box height="2rem" width="2rem">
        <Image src={LogoImage} fit="contain" alt={logoText} margin="0" />
      </Box>
      <LogoText smallSpacing={page === 'icp'}>{logoText}</LogoText>
    </Box>
  )
})

export default PageLogo
